import { useQuery } from '@tanstack/react-query';
import { getSectorGroups } from '../../api/sectorIntelApi';
import type {
  SectorIntelFilters,
  SectorGroupsListResponse,
} from './sectorIntel.types';

const QK_GROUPS = 'sector-groups-list';

export function useSectorGroupsList(filters: SectorIntelFilters) {
  return useQuery<SectorGroupsListResponse>({
    queryKey: [QK_GROUPS, filters],
    queryFn: () => getSectorGroups(filters),
    staleTime: 30_000,
  });
}
